import { render, staticRenderFns } from "./PointOrderList.vue?vue&type=template&id=19a1e493&scoped=true"
import script from "./PointOrderList.vue?vue&type=script&lang=js"
export * from "./PointOrderList.vue?vue&type=script&lang=js"
import style0 from "./PointOrderList.vue?vue&type=style&index=0&id=19a1e493&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a1e493",
  null
  
)

export default component.exports